import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkCard, UitkCardContent, UitkCardLink} from 'uitk-react-cards';
import { Link } from 'react-router-dom';
import { ClickTracker } from 'bernie-analytics';
const LinkTracked = ClickTracker(Link);

export interface CompressionDateOptionProps {
  dateRange: string;
  index: number;
  link: string;
  price: string;
}

export const CompressionDateOption = ({dateRange,
                                      index,
                                      link,
                                      price}: CompressionDateOptionProps) => (
  <UitkCard>
    <UitkCardContent>
      <UitkCardLink>
        <LinkTracked
          linkName="Search alternate dates"
          rfrr={`.Compression.AlternateDates.Option${index + 1}`}
          to={link}
          replace={true}
        >
          {dateRange}
        </LinkTracked>
      </UitkCardLink>
      <div className="uitk-grid all-grid-nowrap pwa-theme--link all-y-padding-two all-x-padding-three">
        <div className="uitk-cell all-cell-1-2">{dateRange}</div>
        <div className="uitk-cell all-cell-1-2 uitk-type-right">
          {price} <UitkIcon name="navigate_next" size={UitkIconSize.SMALL}/>
        </div>
      </div>
    </UitkCardContent>
  </UitkCard>
);
